import React from 'react';
import cx from 'classnames';
import styles from './Overview.module.scss';
import CredentialOverviewTabContainer from 'js/components/credentials/cards/CredentialOverviewTabContainer';

interface CredentialsProps {
  resource: any;
}

export const CredentialOverview = (props: CredentialsProps) => {
  return (
    <div className={cx(styles.overviewContainer, styles.credentialOverviewContainer)}>
      <CredentialOverviewTabContainer disableInitialFetch data={props.resource} />
    </div>
  );
};
